import { render, staticRenderFns } from "./ProductPopover.vue?vue&type=template&id=16a527db&"
import script from "./ProductPopover.vue?vue&type=script&lang=js&"
export * from "./ProductPopover.vue?vue&type=script&lang=js&"
import style0 from "./ProductPopover.vue?vue&type=style&index=0&id=16a527db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports